import React from 'react'
import { Flex, Box, Text } from 'rebass'
import { Label, Message, Checkbox } from './'

const PermissionControls = ({
  email = false,
  sms = false,
  phone = false,
  bg
}) => {
  const count = [email, sms, phone].filter((v) => v).length
  return (
    <div>
      <Text>
        I&#39;d like Citygate to send me news and offers via the following:
      </Text>
      <Flex flexWrap="wrap" width={1}>
        {email && (
          <Box width={1 / count} mb={10}>
            <Label bg={bg}>
              <Checkbox
                name="permissions.marketing.email"
                aria-label="Allow contact by email"
              />
              Email
            </Label>
            <Message for="permissions.marketing.email" />
          </Box>
        )}
        {sms && (
          <Box width={1 / count} mb={10}>
            <Label bg={bg}>
              <Checkbox
                name="permissions.marketing.sms"
                aria-label="Allow contact by sms"
              />
              SMS
            </Label>
            <Message for="permissions.marketing.sms" />
          </Box>
        )}
        {phone && (
          <Box width={1 / count} mb={10}>
            <Label bg={bg}>
              <Checkbox
                name="permissions.marketing.phone"
                aria-label="Allow contact by phone"
              />
              Phone
            </Label>
            <Message for="permissions.marketing.phone" />
          </Box>
        )}
      </Flex>
    </div>
  )
}
export default PermissionControls
